/**
 *  把用户信息存储到localStorage
 */

const userKey = 'admin_user';

export function setUserInfos(data) {
    window.localStorage.setItem(userKey, JSON.stringify(data));
}

export function getUserInfos() {
    return JSON.parse(window.localStorage.getItem(userKey));
}

export function removeUserInfos() {
    window.localStorage.removeItem(userKey);
}